module.exports = __webpack_public_path__ + "static/media/nima-walk.70e93d8a.png";